export default __webpack_public_path__ + "static/men-technology-zoom-exosome-3c2007f6ceee9d2884122b5c30618afd.png";